/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutBillingAddressController', function ($scope, $q, $element, $http, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};
            $scope.Control.InvoiceChanged = false;
            $scope.Control.ExcludeVatChanged = false;
            var controlName = 'BillingAddress';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsValid = true;
            $scope.Control.IsOpen = false;
            $scope.Control.Selected = 0; 
            $scope.Control.SelectedCountry = '';
            $scope.Control.Text = {};
            $scope.Control.Form = {};
            $scope.Control.BillingAsShippingChanged = false;
            $scope.Control.PostCodeFound = false;

            var validators = [];
            var initiallyValidated = false;
            var firstLoad = true, isEdit = false, getVatInfoHasRun = false;
            var vatInfoObj = {};

            var orScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
            var dpScope = angular.element('.x-control.x-angular-control.x-checkoutdeliverypoint').scope();
            var shScope = angular.element('.x-control.x-angular-control.x-checkoutshippingaddress').scope();

            var $prefectureField = $('.form-row.prefecture', $element);
            var $cityField = $('.form-row.city', $element);
            var $areaField = $('.form-row.area', $element);
            var $postCodeField = $('.form-row.postcode', $element);
            var $addressField = $('.form-row.address', $element);

            var prevValues = {
                PostCode: {
                    Country: null,
                    Prefecture: null,
                    City: null,
                    Area: null,
                    PostCode: null
                },
                Street: {
                    Country: null,
                    Prefecture: null,
                    City: null,
                    Area: null,
                    PostCode: null
                }
            };

            var options = {
                callback: function (value) {
                    var fieldName = $(this).data("fieldname");
                    var validate = $(this).data("validate");

                    if (validate)
                        $scope.Control.validateField('Control.Form.' + fieldName);
                },
                wait: 750,
                highlight: false,
                allowSubmit: false,
                captureLength: 1
            };

            $element.find("input[type = text], input[type = tel]").typeWatch(options);

            var savedData = new SavedDataState();

            var setAddress = function (address, reload) {
                var deferred = $q.defer();
                if (addressCompare(address, $.extend($('.x-checkoutorder').scope().Model.Data.Billing)) || !checkoutConfig.billingSetAddressEnabled) {
                    reload = false;
                    deferred.resolve();

                    $('.x-checkoutbillingaddress .form-row.postcode').removeClass('x-loading');
                    $('.x-checkoutbillingaddress .form-row.area').removeClass('x-loading');

                    return deferred.promise;
                }
                address.VatStatus = parseInt(address.VatStatus);
                ControlService.invokeCheckout($scope, $element, 'SetBillingAddress', address).then(function (setResponse) {
                    $scope.setControlValue(controlName, address);
                    if (reload) {
                        if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                            $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                                deferred.resolve();
                                $postCodeField.removeClass('x-loading');
                                $areaField.removeClass('x-loading');
                                $scope.Control.Loading = false;
                            }, function (orderError) {
                                deferred.reject(orderError);
                                $scope.Control.Loading = false;
                            });
                        }
                        else {
                            deferred.resolve();
                            $scope.Control.Loading = false;
                        }
                    }
                    else {
                        $.extend($scope.Order.Current.Billing, _.pick(address, _.filter(_.keys($scope.Order.Current.Billing), function (x) { return x !== "GeoZones" })));

                        deferred.resolve();
                        $scope.Control.Loading = false;
                    }
                }, function (setError) {
                    deferred.reject(setError);
                    $scope.Control.Loading = false;
                });
                return deferred.promise;
            };

            var bindAreaAutoComplete = function () {
                var $postCode = $('input[type="text"][ng-model="Control.Form.PostCode"]', $element);
                var $area = $('input[type="text"][ng-model="Control.Form.Area"]', $element);
                var $city = $('input[type="text"][ng-model="Control.Form.City"]', $element);
                var $countries = $('select[ng-model="Control.Form.Country"]', $element);
                if ($postCode.length > 0 && $area.length > 0 && $city.length > 0 && $countries.length > 0) {

                    var formData = $scope.Control.Form;
                    if (!formData.Country) {
                        if ($scope.Model.Data.Addresses.length > 0)
                            formData = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.Id == $scope.Control.Selected; }));
                        else {
                            formData.Country = "";
                        }
                    }
                    var modelData = $scope.Model.Data;

                    bindPostalCodeLookup($countries, $postCode, $area, $city, modelData, formData, function (area, city, postCode, hasMultipleAreas) {
                        $scope.Locked = true;
                        $scope.Control.Form.PostCode = postCode;
                        $scope.Control.Form.Area = area;
                        $scope.Control.Form.City = city;

                        $scope.Control.PostCodeFound = postCode !== '' && (area !== '' || (area === '' && hasMultipleAreas));

                        if (initiallyValidated) {
                            if ($scope.Model.Data.Config.IsPostCodeVisible && $scope.Model.Data.Config.IsPostCodeRequired) {
                                $scope.Control.validateField('Control.Form.PostCode');
                            }
                            if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaRequired) {
                                $scope.Control.validateField('Control.Form.Area');
                            }
                            if ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityRequired) {
                                $scope.Control.validateField('Control.Form.City');
                            }
                        }
                        else {
                            if ($scope.Control.PostCodeFound) {
                                $scope.Control.Form.PostCodeInvalid = false;
                                $scope.Control.Form.PostCodeError = false;
                            }
                            else {
                                if ($scope.Model.Data.Config.IsPostCodeVisible && $scope.Model.Data.Config.IsPostCodeRequired && $scope.Control.Form.Country) {
                                    $scope.Control.Form.PostCodeInvalid = true;
                                    $scope.Control.Form.PostCodeError = true;
                                }
                            }
                        }

                        $scope.Control.Loading = false;
                        $scope.$apply();

                        var reload = $scope.Control.Form.PostCode && $scope.Control.Form.Area !== '' &&
                            (
                                ($scope.Control.Form.PostCode.length === 5 && $scope.Control.Form.Country === 'GR') ||
                                ($scope.Control.Form.PostCode.length === 4 && $scope.Control.Form.Country === 'CY') ||
                                ($scope.Control.Form.PostCode.length === 7 && $scope.Control.Form.Country === 'CL') ||
                                ($scope.Control.Form.PostCode.length === 4 && $scope.Control.Form.Country === 'HU')
                            );

                        applyChanges(reload).then(function (response) {
                            $scope.Control.Loading = false;
                            $scope.Locked = false;
                        }, function (error) {
                            $scope.Control.Loading = false;
                            $scope.Locked = false;
                            throw error;
                        });
                    }, function (area, postCode) {
                        if (!area || area === '') {
                            $scope.Control.Form.Area = '';
                            $scope.$apply();
                        }
                    });
                }
            };

            var setFormCountry = function () {
                var country = _.first(_.filter($scope.Model.Data.BillingCountries, function (x) { return x.Code == $scope.Control.Form.Country; }));
                $scope.Control.Form.CountryName = country ? country.Name : '';
            };

            var setTextCountry = function () {
                var country = _.first(_.filter($scope.Model.Data.BillingCountries, function (x) { return x.Code == $scope.Control.Text.Country; }));
                $scope.Control.Text.CountryName = country ? country.Name : '';
            };

            var setFormVatStatus = function () {
                var vatStatus = _.first(_.filter($scope.Model.Data.VatStatus, function (x) { return x.Value == String($scope.Control.Form.VatStatus); }));
                $scope.Control.Form.VatStatusName = vatStatus ? vatStatus.Name : '';
            };

            var setFormTaxAgencyId = function () {
                var taxAgency = _.find($scope.Model.Data.TaxAgencies.GR, function (x) { return x.Name === $scope.Control.Form.TaxAgency });
                $scope.Control.Form.TaxAgencyId = taxAgency ? taxAgency.Id : null;
            };

            var setTextVatStatus = function () {
                var vatStatus = _.first(_.filter($scope.Model.Data.VatStatus, function (x) { return x.Value == String($scope.Control.Text.VatStatus); }));
                $scope.Control.Form.VatStatusName = vatStatus ? vatStatus.Name : '';
            };

            var applyChanges = function (reload) {
                var deferred = $q.defer();

                setAddress(CommonUtils.clone($scope.Control.Form), reload).then(function (response) {
                    deferred.resolve(response);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            $scope.$on('newBilling', function () {
                $scope.Control.new();
                $scope.Control.IsOpen = true;
            });

            $scope.$on('setSelectedBilling', function () {
                $scope.Control.Selected = $scope.SelectedId;
                $scope.Control.setAddress();
            });

            if (checkoutOverrides && checkoutOverrides.Billing && typeof checkoutOverrides.Billing.AddWatch === 'function') {
                checkoutOverrides.Billing.AddWatch($scope);
            }

            $scope.Control.new = function () {

                var isInvoice = false;

                if ($scope.Control.Form.IsInvoice) isInvoice = true;
                
                $scope.Control.Form = {
                    IsInvoice: isInvoice
                };

                if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.Billing && $scope['Order'].Current.Billing.Country) {
                    $scope.Control.Form.Country = $scope['Order'].Current.Billing.Country;
                }

                if (checkoutOverrides && checkoutOverrides.Billing && typeof checkoutOverrides.Billing.ExtendNewBillingAddress === 'function') {
                    checkoutOverrides.Billing.ExtendNewBillingAddress($scope);
                }

                $scope.Control.SelectedError = false;

                $scope.Control.PostCodeFound = true;

                $scope.Control.Loading = false;

                setAddress($scope.Control.Form).then(function (response) {
                    $scope.Control.Loading = false;
                    $scope.Control.Selected = 0;
                    $scope.Control.IsOpen = true;

                    if (checkoutOverrides && checkoutOverrides.Billing && typeof checkoutOverrides.Billing.SetHiddenFields === 'function') {
                        return checkoutOverrides.Billing.SetHiddenFields(orScope,$scope);
                    }

                }, function (error) {
                    $scope.Control.Loading = false;
                    throw error;
                });
            };

            $scope.Control.edit = function () {
                //get exclude vat info before edit
                $scope.Control.getVatInfo();
                
                $scope.Control.Form = {};
                $scope.Control.SelectedError = false;

                $scope.Control.PostCodeFound = true;

                var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.Id == $scope.Control.Selected; }));

                if (selectedAddress) {
                    $scope.Control.Loading = false;
                    angular.extend($scope.Control.Form, selectedAddress, vatInfoObj);
                    $scope.Control.IsOpen = true;

                    var selectedTitle = _.first(_.filter($scope.Model.Data.Titles, function (x) { return x.Name === $scope.Control.Form.Title; }));
                    if (!selectedTitle)
                        $scope.Control.Form.Title = '';

                    isEdit = true;
                    eInvoiceInit();

                    var clonedAddress = CommonUtils.clone($scope.Control.Form);

                    $scope.Control.Loading = false;
                    setAddress(clonedAddress).then(function (response) {
                        $scope.Control.Loading = false;
                    }, function (error) {
                        $scope.Control.Loading = false;
                        throw error;
                    });
                }
            };

            $scope.Control.hideReceiptForB2BUsers = function () {
                if ($scope.Order.Current.IsB2BUser && $scope.Model.Data.Config.IsInvoiceEnabled && !$scope.Model.Data.Config.IsReceiptEnabledForB2B) {
                    $scope.Control.Form.IsInvoice = true;
                    return true;
                } else {
                    return false;
                }
            };

            $scope.Control.getVatInfo = function () {
                vatInfoObj = {
                    NormalVat: $scope.Control.Form.NormalVat,
                    ExcludeVat: $scope.Control.Form.ExcludeVat,
                    ExcludeVatJson : $scope.Control.Form.ExcludeVatJson
                };
            };

            $scope.Control.resetVatInfo = function () {
                if ($scope.Control.Form.NormalVat) $scope.Control.Form.NormalVat = false;
                if ($scope.Control.Form.ExcludeVat) $scope.Control.Form.ExcludeVat = false;
                if ($scope.Control.Form.ExcludeVatJson) $scope.Control.Form.ExcludeVatJson = '';
            };

            $scope.Control.setAddress = function (address, reload) {

                $scope.Control.Text = {};

                if ($scope.Order.Current.IsLoggedIn && $scope.Model.Data.Addresses.length > 0) {
                    $scope.Control.IsOpen = false;
                }
                var selectedAddress = {};
                if ($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && dpScope.Control.Selected.Code === 'onSite') {
                    var shouldReload = false;
                    if (address) {
                        var isInvoice;
                        var findCurrentWithBilling = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.Id == address.Id; }));

                        if (findCurrentWithBilling) {
                            selectedAddress = findCurrentWithBilling;
                            if (!addressCompare(address, findCurrentWithBilling)) {
                                addressSet(address, selectedAddress);
                                shouldReload = true;
                            }
                        }
                        else {
                            var addresses = JSON.parse(JSON.stringify($scope.Model.Data.Addresses));
                            selectedAddress = _.first(_.filter(addresses, function (x) { return x.Id != 0; })) || $scope.Control.Form;
                            addressSet(address, selectedAddress);
                        }

                    } else {
                        if ($scope.Control.Selected) {
                            selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) {
                                return x.Id == $scope.Control.Selected;
                            }));
                        }
                        else {
                            selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) {
                                return x.Id == shScope.Control.Selected;
                            }));
                        }

                    }
                    if (selectedAddress) {
                        $scope.Control.Form.IsInvoice = selectedAddress.IsInvoice;                      
                        $scope.Control.IsOpen = true;
                    }

                    if (!address && !$scope.Control.Selected && !selectedAddress) {
                        selectedAddress = shScope.Control.Form;
                    }
                } else {
                    if ($scope.Control.Selected) {
                        selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) {
                            return x.Id == $scope.Control.Selected;
                        }));
                    }
                    else {
                        selectedAddress = address || _.first(_.filter($scope.Model.Data.Addresses, function (x) {
                            return x.Id != 0;
                        }));
                    }

                }

                if (!$scope.Control.IsOpen) {
                    var selectedCountry = selectedAddress ? _.first(_.filter($scope.Model.Data.BillingCountries, function (c) { return selectedAddress.Country == c.Code; })) : null;
                    $scope.Control.IsOpen = selectedAddress === undefined || (selectedAddress.PostCode != "" && selectedAddress.Area == "" && (selectedCountry ? selectedCountry.AreasCount > 1 : false));
                }

                if (selectedAddress !== undefined && !isAddressOk(selectedAddress))
                    $scope.Control.IsOpen = true;

                if (selectedAddress !== undefined && !$scope.Control.IsOpen)
                    $scope.Control.resetVatInfo();

                $scope.Control.Loading = false;

                angular.extend($scope.Control.Form, selectedAddress || {});

                if (!$scope.Control.IsOpen) {
                    angular.extend($scope.Control.Text, selectedAddress || {});
                }

                if (selectedAddress && $scope.Control.Form.IsInvoice) {
                    selectedAddress.IsInvoice = $scope.Control.Form.IsInvoice;
                    selectedAddress.CompanyName = $scope.Control.Form.CompanyName;
                    selectedAddress.Occupation = $scope.Control.Form.Occupation;
                    selectedAddress.Headquarters = $scope.Control.Form.Headquarters;
                    selectedAddress.NormalVat = $scope.Control.Form.NormalVat;
                    selectedAddress.ExcludeVat = $scope.Control.Form.ExcludeVat;
                    selectedAddress.ExcludeVatJson = $scope.Control.Form.ExcludeVatJson;

                    selectedAddress.TaxAgency = $scope.Control.Form.TaxAgency;
                    selectedAddress.TaxIdentifier = $scope.Control.Form.TaxIdentifier;
                    selectedAddress.PurchaseOrderNumber = $scope.Control.Form.PurchaseOrderNumber;
                    selectedAddress.TaxAgencyId = $scope.Control.Form.TaxAgencyId;

                    selectedAddress.eInvoice = $scope.Control.Form.eInvoice;
                    angular.extend($scope.Control.Form, selectedAddress || {});
                }

                var reloadOrder = reload === undefined || reload === true || shouldReload === true;

                setAddress(CommonUtils.clone(selectedAddress), reloadOrder).then(function (response) {
                    var selectedCountry = selectedAddress ? _.first(_.filter($scope.Model.Data.BillingCountries, function (c) { return selectedAddress.Country == c.Code; })) : null;
                    if (selectedAddress !== undefined && selectedAddress.PostCode != "" && selectedAddress.Area == "" && (selectedCountry ? selectedCountry.AreasCount > 1 : false)) {
                        $('input[type="text"][ng-model="Control.Form.Area"]', $element).val("");
                        $('input', $postCodeField).trigger('keyup');
                    } else {
                        $('.postal-code-areas', $element).hide();
                    }

                    if (!firstLoad && selectedAddress !== undefined && selectedAddress.IsInvoice && (selectedAddress.ExcludeVatJson === "" || selectedAddress.ExcludeVatJson === undefined)) {
                        $scope.Control.checkVAT();
                    }

                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.Loading = false;
                    throw error;
                });

                $scope.Control.SelectedError = false;
            };

            $scope.Control.validateField = function (name) {
                if (initiallyValidated) {
                    _.first(_.filter(validators, function (x) { return x.name == name })).fn();
                }
            };

            $scope.Control.setInvoice = function (value) {

                $scope.Control.Form.IsInvoice = value;

                if (!value) {
                    Validation.reset($scope, 'Control.Form.CompanyName');
                    Validation.reset($scope, 'Control.Form.Occupation');
                    Validation.reset($scope, 'Control.Form.Headquarters');
                    Validation.reset($scope, 'Control.Form.TaxAgency');
                    Validation.reset($scope, 'Control.Form.TaxIdentifier');
                    Validation.reset($scope, 'Control.Form.PurchaseOrderNumber');
                    Validation.reset($scope, 'Control.Form.VatStatus');
                }

                $element.get(0).set(true);

                if (checkoutOverrides && checkoutOverrides.Billing && typeof checkoutOverrides.Billing.ExtendSetInvoice === 'function') {
                    checkoutOverrides.Billing.ExtendSetInvoice($scope, value);
                }
            };

            $scope.Control.resetAutofillInputs = function () {
                if ($scope.Model.Data.Config.IsPostCodeAutofill) {
                    $scope.Control.Form.PostCode = "";
                }
                if ($scope.Model.Data.Config.IsAddressLine1Autofill) {
                    $scope.Control.Form.Address = "";
                }
            };

            $scope.Control.getServiceData = function (element, isChanged) {
                if (element === 'country') {
                    $scope.Control.resetAutofillInputs();
                    if ($scope.Model.Data.Config.IsPrefectureVisible && $scope.Model.Data.Config.IsPrefectureAutofill) {
                        $scope.Control.getPrefectures(isChanged);
                    } else if ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityAutofill) {
                        $scope.Control.getCities(isChanged);
                    } else if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaAutofill) {
                        $scope.Control.getAreas(isChanged);
                    }
                }

                if (element === 'prefecture') {
                    $scope.Control.resetAutofillInputs();
                    if ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityAutofill) {
                        $scope.Control.getCities(isChanged);
                    } else if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaAutofill) {
                        $scope.Control.getAreas(isChanged);
                    }
                }

                if (element === 'city') {
                    $scope.Control.resetAutofillInputs();
                    if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaAutofill) {
                        $scope.Control.getAreas(isChanged);
                    }
                }

                if (element === 'area') {
                    $scope.Control.resetAutofillInputs();
                }
            };

            $scope.Control.getPrefectures = function (isChanged) {
                if ($scope.Model.Data.Config.IsPrefectureAutofill) {
                    if ($scope.Control.Form.Country) {
                        $prefectureField.addClass('x-loading');

                        $http({
                            async: true,
                            method: "POST",
                            contentType: 'application/json; charset=UTF-8',
                            ContentType: 'application/json; charset=UTF-8',
                            url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                            data: {
                                fields: 'prefecture',
                                countryCode: $scope.Control.Form.Country
                            }
                        }).then(function mySuccess(response) {
                            $scope.Model.Data.Prefectures = _.map(response.data.data, function (obj) { return obj.prefecture; });

                            if ($scope.Model.Data.Prefectures.length < 1 || isChanged) {
                                $scope.Control.Form.Prefecture = "";
                                $scope.Control.Form.City = "";
                                $scope.Control.Form.Area = "";
                                $scope.Model.Data.Cities = [];
                                $scope.Model.Data.Areas = [];
                            }

                            $scope.Control.applyChanges();

                            if (checkoutConfig.hasSearch.prefectureSearch) $scope.Control.Search($prefectureField);
                            if (checkoutConfig.hasSearch.citySearch) $scope.Control.Search($cityField);
                            if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                            $prefectureField.removeClass('x-loading');
                        }, function myError(response) {
                            $prefectureField.removeClass('x-loading');
                        });
                    } else {
                        $scope.Control.Form.Prefecture = "";
                        $scope.Control.Form.City = "";
                        $scope.Control.Form.Area = "";
                        $scope.Model.Data.Cities = [];
                        $scope.Model.Data.Areas = [];

                        $scope.Control.applyChanges();

                        if (checkoutConfig.hasSearch.prefectureSearch) $scope.Control.Search($prefectureField);
                        if (checkoutConfig.hasSearch.citySearch) $scope.Control.Search($cityField);
                        if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                    }
                }
            };

            $scope.Control.getCities = function (isChanged) {
                if ($scope.Model.Data.Config.IsCityAutofill) {

                    if (typeof $scope.Control.Form.Prefecture === 'undefined') $scope.Control.Form.Prefecture = "";

                    var run = false;

                    if ($scope.Model.Data.Config.IsPrefectureAutofill && $scope.Model.Data.Config.IsPrefectureVisible) {
                        if ($scope.Control.Form.Country && $scope.Control.Form.Prefecture) {
                            run = true;
                        }
                    } else {
                        if ($scope.Control.Form.Country) {
                            run = true;
                        }
                    }

                    if (run) {
                        $cityField.addClass('x-loading');

                        $http({
                            async: true,
                            method: "POST",
                            contentType: 'application/json; charset=UTF-8',
                            ContentType: 'application/json; charset=UTF-8',
                            url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                            data: {
                                fields: 'city',
                                countryCode: $scope.Control.Form.Country,
                                prefecture: $scope.Control.Form.Prefecture
                            }
                        }).then(function mySuccess(response) {
                            $scope.Model.Data.Cities = _.map(response.data.data, function (obj) { return obj.city; });

                            if ($scope.Model.Data.Cities.length < 1 || isChanged) {
                                $scope.Control.Form.City = "";
                                $scope.Control.Form.Area = "";
                                $scope.Model.Data.Areas = [];
                            }

                            $scope.Control.applyChanges();

                            if (checkoutConfig.hasSearch.citySearch) $scope.Control.Search($cityField);
                            if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                            $cityField.removeClass('x-loading');
                        }, function myError(response) {
                            $cityField.removeClass('x-loading');
                        });

                    } else {
                        $scope.Control.Form.City = "";
                        $scope.Control.Form.Area = "";
                        $scope.Model.Data.Areas = [];

                        $scope.Control.applyChanges();

                        if (checkoutConfig.hasSearch.citySearch) $scope.Control.Search($cityField);
                        if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                    }
                }
            };

            $scope.Control.getAreas = function (isChanged) {
                if ($scope.Model.Data.Config.IsAreaAutofill) {

                    if (typeof $scope.Control.Form.Prefecture === 'undefined') $scope.Control.Form.Prefecture = "";
                    if (typeof $scope.Control.Form.City === 'undefined') $scope.Control.Form.City = "";

                    var run = false;

                    if ($scope.Control.Form.Country) {
                        if ($scope.Model.Data.Config.IsPrefectureAutofill && $scope.Model.Data.Config.IsPrefectureVisible) {
                            if ($scope.Control.Form.Prefecture) {
                                if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                                    if ($scope.Control.Form.City) {
                                        run = true;
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                            if ($scope.Control.Form.City) {
                                run = true;
                            }
                        } else {
                            run = true;
                        }
                    }

                    if (run) {
                        $areaField.addClass('x-loading');

                        $http({
                            async: true,
                            method: "POST",
                            contentType: 'application/json; charset=UTF-8',
                            ContentType: 'application/json; charset=UTF-8',
                            url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                            data: {
                                fields: 'geoArea',
                                countryCode: $scope.Control.Form.Country,
                                prefecture: $scope.Control.Form.Prefecture,
                                city: $scope.Control.Form.City
                            }
                        }).then(function mySuccess(response) {
                            $scope.Model.Data.Areas = _.map(response.data.data, function (obj) { return obj.geoArea; });

                            if ($scope.Model.Data.Areas.length < 1 || isChanged) {
                                $scope.Control.Form.Area = "";
                            }

                            $scope.Control.applyChanges();

                            if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                            $areaField.removeClass('x-loading');
                        }, function myError(response) {
                            $areaField.removeClass('x-loading');
                        });
                    } else {
                        $scope.Control.Form.Area = "";

                        $scope.Control.applyChanges();

                        if (checkoutConfig.hasSearch.areaSearch) $scope.Control.Search($areaField);
                    }
                }
            };

            $scope.Control.getPostCodes = function (isChanged) {
                if ($scope.Model.Data.Config.IsPostCodeAutofill) {

                    if (typeof $scope.Control.Form.Prefecture === 'undefined') $scope.Control.Form.Prefecture = "";
                    if (typeof $scope.Control.Form.City === 'undefined') $scope.Control.Form.City = "";
                    if (typeof $scope.Control.Form.Area === 'undefined') $scope.Control.Form.Area = "";

                    var run = false;

                    if ($scope.Control.Form.Country) {
                        if ($scope.Model.Data.Config.IsPrefectureAutofill && $scope.Model.Data.Config.IsPrefectureVisible) {
                            if ($scope.Control.Form.Prefecture) {
                                if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                                    if ($scope.Control.Form.City) {
                                        if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                                            if ($scope.Control.Form.Area) {
                                                run = true;
                                            }
                                        } else {
                                            run = true;
                                        }
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                            if ($scope.Control.Form.City) {
                                if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                                    if ($scope.Control.Form.Area) {
                                        run = true;
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                            if ($scope.Control.Form.Area) {
                                run = true;
                            }
                        } else {
                            run = true;
                        }
                    }

                    if (run) {
                        if (prevValues.PostCode.Country != $scope.Control.Form.Country || prevValues.PostCode.Prefecture != $scope.Control.Form.Prefecture || prevValues.PostCode.City != $scope.Control.Form.City || prevValues.PostCode.Area != $scope.Control.Form.Area || prevValues.PostCode.PostCode != $scope.Control.Form.PostCode) {
                            prevValues.PostCode.Country = $scope.Control.Form.Country;
                            prevValues.PostCode.Prefecture = $scope.Control.Form.Prefecture;
                            prevValues.PostCode.City = $scope.Control.Form.City;
                            prevValues.PostCode.Area = $scope.Control.Form.Area;
                            prevValues.PostCode.PostCode = $scope.Control.Form.PostCode;

                            $postCodeField.addClass('x-loading');

                            $http({
                                async: true,
                                method: "POST",
                                contentType: 'application/json; charset=UTF-8',
                                ContentType: 'application/json; charset=UTF-8',
                                url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                                data: {
                                    fields: 'postalCode',
                                    countryCode: $scope.Control.Form.Country,
                                    prefecture: $scope.Control.Form.Prefecture,
                                    city: $scope.Control.Form.City,
                                    postalCode: '*' + $scope.Control.Form.PostCode + '*'
                                }
                            }).then(function mySuccess(response) {
                                $scope.Model.Data.PostCodes = _.map(response.data.data, function (obj) { return obj.postalCode; });

                                $scope.Control.showPostCodes = true;
                                $postCodeField.removeClass('x-loading');
                                $('.autofill-input', $postCodeField).focus();  
                            }, function myError(response) {
                                $postCodeField.removeClass('x-loading');
                            });
                        } else {
                            $scope.Control.showPostCodes = true;
                        }
                    }
                }
            };

            $scope.Control.getStreets = function (isChanged) {
                if ($scope.Model.Data.Config.IsAddressLine1Autofill) {

                    if (typeof $scope.Control.Form.Prefecture === 'undefined') $scope.Control.Form.Prefecture = "";
                    if (typeof $scope.Control.Form.City === 'undefined') $scope.Control.Form.City = "";
                    if (typeof $scope.Control.Form.Area === 'undefined') $scope.Control.Form.Area = "";

                    var run = false;

                    if ($scope.Control.Form.Country) {
                        if ($scope.Model.Data.Config.IsPrefectureAutofill && $scope.Model.Data.Config.IsPrefectureVisible) {
                            if ($scope.Control.Form.Prefecture) {
                                if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                                    if ($scope.Control.Form.City) {
                                        if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                                            if ($scope.Control.Form.Area) {
                                                run = true;
                                            }
                                        } else {
                                            run = true;
                                        }
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsCityAutofill && $scope.Model.Data.Config.IsCityVisible) {
                            if ($scope.Control.Form.City) {
                                if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                                    if ($scope.Control.Form.Area) {
                                        run = true;
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else if ($scope.Model.Data.Config.IsAreaAutofill && $scope.Model.Data.Config.IsAreaVisible) {
                            if ($scope.Control.Form.Area) {
                                run = true;
                            }
                        } else {
                            run = true;
                        }
                    }

                    if (run) {
                        if (prevValues.Street.Country != $scope.Control.Form.Country || prevValues.Street.Prefecture != $scope.Control.Form.Prefecture || prevValues.Street.City != $scope.Control.Form.City || prevValues.Street.Area != $scope.Control.Form.Area || prevValues.Street.Address != $scope.Control.Form.Address) {
                            prevValues.Street.Country = $scope.Control.Form.Country;
                            prevValues.Street.Prefecture = $scope.Control.Form.Prefecture;
                            prevValues.Street.City = $scope.Control.Form.City;
                            prevValues.Street.Area = $scope.Control.Form.Area;
                            prevValues.Street.Address = $scope.Control.Form.Address;

                            $addressField.addClass('x-loading');

                            $http({
                                async: true,
                                method: "POST",
                                contentType: 'application/json; charset=UTF-8',
                                ContentType: 'application/json; charset=UTF-8',
                                url: document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Address/GetAddressInfo',
                                data: {
                                    fields: 'street',
                                    countryCode: $scope.Control.Form.Country,
                                    prefecture: $scope.Control.Form.Prefecture,
                                    city: $scope.Control.Form.City,
                                    postalCode: '',
                                    street: '*' + $scope.Control.Form.Address + '*'
                                }
                            }).then(function mySuccess(response) {
                                $scope.Model.Data.Streets = _.map(response.data.data, function (obj) { return obj.street; });

                                $scope.Control.showStreets = true;
                                $addressField.removeClass('x-loading');
                                $('.autofill-input', $addressField).focus();  
                            }, function myError(response) {
                                $addressField.removeClass('x-loading');
                            });
                        } else {
                            $scope.Control.showStreets = true;
                        }
                    }
                }
            };

            $scope.Control.Search = function (el) {

                var $el = $(el);

                if ($('.chosen-container', $el).length > 0) {
                    if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.UpdateChosenSearch === 'function') {
                        angular.element($el).ready(function () {
                            checkoutOverrides.Generic.UpdateChosenSearch($el);
                        });
                    }
                } else {
                    if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.InitChosenSearch === 'function') {
                        angular.element($el).ready(function () {
                            checkoutOverrides.Generic.InitChosenSearch($el);
                        });
                    }
                }
            };

            var calculateSelectedCountry = function () {

                if ($scope.Order) {
                    var selectedCountry = '';

                    if ($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && dpScope.Control.Selected.Code === 'onSite') {
                        if (shScope.Control.IsOpen || !$scope.Order.Current.IsLoggedIn) {
                            selectedCountry = shScope.Control.Form.Country;
                        }
                        else {
                            if (shScope.Control.Selected && shScope.Control.Selected !== 0) {
                                var selectedAddress = _.first(_.filter(shScope.Model.Data.Addresses, function (x) {
                                    return x.Id === parseInt(shScope.Control.Selected);
                                }));

                                if (selectedAddress) {
                                    selectedCountry = selectedAddress.Country;
                                }
                            }
                        }
                    }
                    else {
                        if ($scope.Control.IsOpen || !$scope.Order.Current.IsLoggedIn) {
                            selectedCountry = $scope.Control.Form.Country;
                        }
                        else {
                            if ($scope.Control.Selected && $scope.Control.Selected !== 0) {
                                var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) {
                                    return x.Id === parseInt($scope.Control.Selected);
                                }));

                                if (selectedAddress) {
                                    selectedCountry = selectedAddress.Country;
                                }
                            }
                        }
                    }

                    $scope.Control.SelectedCountry = selectedCountry || '';

                    if (initiallyValidated && $scope.Control.Form.IsInvoice) {
                        if ($scope.Control.SelectedCountry !== '') {
                            if ($scope.Model.Data.TaxAgencies[selectedCountry] && $scope.Model.Data.TaxAgencies[selectedCountry].length > 1) {
                                var firstTaxAgency = _.first(_.filter($scope.Model.Data.TaxAgencies[selectedCountry], function (x) { return x.Name == $scope.Control.Form.TaxAgency; }));
                                if (!firstTaxAgency && $scope.Control.Form.TaxAgency !== "") {
                                    $scope.Control.Form.TaxAgency = '';
                                    $scope.Control.Form.TaxAgencyId = null;

                                    if ($scope.Model.Data.Config.IsTaxAgencyVisible && $scope.Model.Data.Config.IsTaxAgencyRequired) {
                                        $scope.Control.Form.TaxAgencyRequired = true;
                                        $scope.Control.Form.TaxAgencyError = true;
                                        $scope.Control.Form.IsValid = false;
                                    }
                                }
                            }
                        }
                    }
                }

                if ($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && dpScope.Control.Selected.Code === 'onSite' && $scope.Control.Form.IsInvoice) {
                    $scope.Control.countryChange(false);
                }
            };

            var eInvoiceInit = function () {
                if (orScope && (firstLoad || isEdit)) {
                    var UserCanChangeValue = orScope.Model.Data.Billing.UserCanChangeValue;
                    var EInvoiceModuleEnabled = orScope.Model.Data.Billing.EInvoiceModuleEnabled;
                    var eInvoice = orScope.Model.Data.Billing.eInvoice;

                    $scope.Control.Form.UserCanChangeValue = UserCanChangeValue;
                    $scope.Control.Form.EInvoiceModuleEnabled = EInvoiceModuleEnabled;
                    $scope.Control.Form.eInvoice = eInvoice;

                    firstLoad = false;
                    isEdit = false;
                }
            };

            dpScope.$watch('Control.Selected.Code', function (newValue, prevValue) {
                calculateSelectedCountry();
            });

            shScope.$watch('Control.Selected', function (newValue, prevValue) {
                calculateSelectedCountry();
            });

            shScope.$watch('Control.Form.Country', function (newValue, prevValue) {
                calculateSelectedCountry();
            });

            orScope.$watch('Model.Data.Billing', function (newValue, prevValue) {
                eInvoiceInit();
            });

            $scope.$watch('Control.Selected', function (newValue, prevValue) {
                calculateSelectedCountry();

                if (!newValue || newValue == 0) {
                    Validation.reset($scope, 'Control.Form.Title');
                    Validation.reset($scope, 'Control.Form.FirstName');
                    Validation.reset($scope, 'Control.Form.LastName');
                    Validation.reset($scope, 'Control.Form.Email');
                    Validation.reset($scope, 'Control.Form.Phone');
                    Validation.reset($scope, 'Control.Form.Fax');
                    Validation.reset($scope, 'Control.Form.Mobile');
                    Validation.reset($scope, 'Control.Form.Address');
                    Validation.reset($scope, 'Control.Form.Streetnumber');
                    Validation.reset($scope, 'Control.Form.Address2');
                    Validation.reset($scope, 'Control.Form.PostCode');
                    Validation.reset($scope, 'Control.Form.Area');
                    Validation.reset($scope, 'Control.Form.City');
                    Validation.reset($scope, 'Control.Form.Country');
                    Validation.reset($scope, 'Control.Form.Prefecture');

                    if ($scope.Model.Data.Addresses.length > 0) {
                        $scope.Control.getPrefectures();
                        $scope.Control.getCities();
                        $scope.Control.getAreas();
                    }
                }

            });

            $scope.$watch('Control.IsOpen', function (newValue, prevValue) {
                if (newValue == true) {
                    $scope.Control.getPrefectures();
                    $scope.Control.getCities();
                    $scope.Control.getAreas();
                }
            });

            $scope.$watch('Control.Form.Country', function (newValue, prevValue) {
                calculateSelectedCountry();
            });

            $scope.$watch('BillingAsShipping', function (newValue, prevValue) {

                $scope.Control.BillingAsShippingChanged = true;

                var isBillingAsShipping = newValue;

                calculateSelectedCountry();

                if (orScope.Model.Data.DeliveryPoint.Code === 'fromStore')
                    return;

                if (!newValue) {
                    Validation.reset($scope, 'Control.Form.Title');
                    Validation.reset($scope, 'Control.Form.FirstName');
                    Validation.reset($scope, 'Control.Form.LastName');
                    Validation.reset($scope, 'Control.Form.Email');
                    Validation.reset($scope, 'Control.Form.Phone');
                    Validation.reset($scope, 'Control.Form.Fax');
                    Validation.reset($scope, 'Control.Form.Mobile');
                    Validation.reset($scope, 'Control.Form.Address');
                    Validation.reset($scope, 'Control.Form.Streetnumber');
                    Validation.reset($scope, 'Control.Form.Address2');
                    Validation.reset($scope, 'Control.Form.PostCode');
                    Validation.reset($scope, 'Control.Form.Area');
                    Validation.reset($scope, 'Control.Form.City');
                    Validation.reset($scope, 'Control.Form.Country');
                    Validation.reset($scope, 'Control.Form.Prefecture');

                }

                var selectedShippingAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) {
                    return x.Id == shScope.Control.Selected;
                }));

                if (selectedShippingAddress) {

                    if (isBillingAsShipping) {

                        selectedShippingAddress = $.extend({}, selectedShippingAddress, $scope.Order.Current.Shipping);
                        if ($scope.Control.Form.IsInvoice) {
                            selectedShippingAddress.IsInvoice = $scope.Control.Form.IsInvoice;
                            selectedShippingAddress.CompanyName = $scope.Control.Form.CompanyName;
                            selectedShippingAddress.Occupation = $scope.Control.Form.Occupation;
                            selectedShippingAddress.Headquarters = $scope.Control.Form.Headquarters;
                            selectedShippingAddress.NormalVat = $scope.Control.Form.NormalVat;
                            selectedShippingAddress.ExcludeVat = $scope.Control.Form.ExcludeVat;
                            selectedShippingAddress.ExcludeVatJson = $scope.Control.Form.ExcludeVatJson;
                            selectedShippingAddress.TaxAgency = $scope.Control.Form.TaxAgency;
                            selectedShippingAddress.TaxIdentifier = $scope.Control.Form.TaxIdentifier;
                            selectedShippingAddress.PurchaseOrderNumber = $scope.Control.Form.PurchaseOrderNumber;
                            selectedShippingAddress.TaxAgencyId = $scope.Control.Form.TaxAgencyId,
                            selectedShippingAddress.eInvoice = $scope.Control.Form.eInvoice;
                        }
                    }

                    $scope.Control.setAddress(selectedShippingAddress);
                } else {
                    var defaultAddress = null, filledInvoice = null;
                    if ($scope.Control.Form.IsInvoice) {
                        filledInvoice = {
                            IsInvoice: $scope.Control.Form.IsInvoice,
                            CompanyName: $scope.Control.Form.CompanyName,
                            Occupation: $scope.Control.Form.Occupation,
                            Headquarters: $scope.Control.Form.Headquarters,
                            NormalVat: $scope.Control.Form.NormalVat,
                            ExcludeVat: $scope.Control.Form.ExcludeVat,
                            ExcludeVatJson: $scope.Control.Form.ExcludeVatJson,
                            TaxAgency: $scope.Control.Form.TaxAgency,
                            TaxIdentifier: $scope.Control.Form.TaxIdentifier,
                            PurchaseOrderNumber: $scope.Control.Form.PurchaseOrderNumber,
                            TaxAgencyId: $scope.Control.Form.TaxAgencyId,
                            eInvoice: $scope.Control.Form.eInvoice
                        };
                    }
                    $scope.Control.Text = {};
                    if (isBillingAsShipping) {
                        defaultAddress = $.extend({}, filledInvoice, $scope.Order.Current.Shipping);
                    } else {
                        defaultAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.IsDefault == true; })); 
                        if (defaultAddress) {
                            $scope.Control.Selected = defaultAddress.Id;
                        } else {
                            $scope.Control.Form = {};
                            $scope.Control.Form = $.extend({}, filledInvoice, $scope.Control.Form);
                            $scope.Control.Form.VatStatus = $scope.Order.Current.Billing.VatStatus;
                            if ($scope.Model.Data.BillingCountries.length <= 1) {
                                $scope.Control.Form.Country = $scope.Model.Data.BillingCountries[0].Code;
                                $scope.Control.Form.CountryName = $scope.Model.Data.BillingCountries[0].Name;
                            }

                            $scope.Control.getPrefectures();
                            $scope.Control.getCities();
                            $scope.Control.getAreas();
                        }
                    }
                    $scope.Control.setAddress(defaultAddress);
                }

            });

            $scope.$watch('Control.Form.IsInvoice', function (newValue, prevValue) {
                $scope.Control.InvoiceChanged = true;

                if (!$scope.Control.Form.IsInvoice) {
                    $scope.Control.Form.CompanyName = '';
                    $scope.Control.Form.Occupation = '';
                    $scope.Control.Form.Headquarters = '';
                    $scope.Control.Form.NormalVat = false;
                    $scope.Control.Form.ExcludeVat = false;
                    $scope.Control.Form.ExcludeVatJson = '';
                    $scope.Control.Form.TaxAgency = '';
                    $scope.Control.Form.TaxIdentifier = '';
                    $scope.Control.Form.PurchaseOrderNumber = '';
                    $scope.Control.Form.TaxAgencyId = null;
                    $scope.Control.Form.eInvoice = null;
                }

                if (checkoutOverrides && checkoutOverrides.Billing && typeof checkoutOverrides.Billing.ExtendIsInvoiceWatch === 'function') {
                    checkoutOverrides.Billing.ExtendIsInvoiceWatch(newValue, prevValue, orScope, $scope);
                }
            });

            $scope.Control.applyChanges = function (name) {

                if (!savedData.hasChanged($scope.Control.Form))
                    return;

                $scope.Control.Loading = false;
                setFormCountry();
                setFormVatStatus();
                setFormTaxAgencyId();

                var shouldReload = ($scope.Control.Form.IsInvoice && isAddressOk($scope.Control.Form)) || $scope.Control.InvoiceChanged || $scope.Control.ExcludeVatChanged;
                $scope.Control.InvoiceChanged = false;
                $scope.Control.ExcludeVatChanged = false;

                applyChanges(['country', 'postcode'].indexOf(name) !== -1 || shouldReload).then(function (response) {
                    savedData.setData($scope.Control.Form);
                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.Loading = false;
                    throw error;
                });
            };

            $scope.Control.getCountryName = function (code) {
                var country = _.first(_.filter($scope.Model.Data.BillingCountries, function (x) { return x.Code === code; }));
                return country ? country.Name : country;
            };

            $scope.Control.eInvoiceState = function (value) {
                if (value === true) {
                    $scope.Control.Form.eInvoice = true;
                } else if (value === false) {
                    $scope.Control.Form.eInvoice = false;
                } else {
                    $scope.Control.Form.eInvoice = null;
                }
            };

            $scope.Control.showField = function () {
                if (checkoutOverrides && checkoutOverrides.Billing && typeof checkoutOverrides.Billing.ShowBillingFields === 'function') {
                   return checkoutOverrides.Billing.ShowBillingFields($scope);
                }
            };

            var suppressPostCodeInputFocusedChange = false, suppressStreetInputFocusedChange = false;

            $scope.Control.bindPostCode = function (postCode) {
                $scope.Control.Form.PostCode = postCode;
                $scope.Control.showPostCodes = false;
                $scope.Control.applyChanges();
            };

            $scope.Control.hidePostCodeList = function () {
                if (suppressPostCodeInputFocusedChange === true) {
                    suppressPostCodeInputFocusedChange = false;
                    return false;
                }
                $scope.Control.showPostCodes = false;
            };

            $scope.Control.suppressPostCodeInputFocus = function () {
                suppressPostCodeInputFocusedChange = true;
            };

            $scope.Control.bindStreet = function (street) {
                $scope.Control.Form.Address = street;
                $scope.Control.showStreets = false;
                $scope.Control.applyChanges();
            };

            $scope.Control.hideStreetList = function () {
                if (suppressStreetInputFocusedChange === true) {
                    suppressStreetInputFocusedChange = false;
                    return false;
                }
                $scope.Control.showStreets = false;
            };

            $scope.Control.suppressStreetInputFocus = function () {
                suppressStreetInputFocusedChange = true;
            };

            validators.push({
                name: 'Control.Form.Title',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Title');
                    if ($scope.Model.Data.Config.IsTitleVisible && $scope.Model.Data.Config.IsTitleRequired) {
                        Validation.require($scope, 'Control.Form.Title').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.FirstName',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.FirstName');
                    if ($scope.Model.Data.Config.IsFirstNameVisible && $scope.Model.Data.Config.IsFirstNameRequired) {
                        Validation.require($scope, 'Control.Form.FirstName').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.LastName',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.LastName');
                    if ($scope.Model.Data.Config.IsLastNameVisible && $scope.Model.Data.Config.IsLastNameRequired) {
                        Validation.require($scope, 'Control.Form.LastName').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Email',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Email');
                    if ($scope.Model.Data.Config.IsEmailVisible && $scope.Model.Data.Config.IsEmailRequired) {
                        Validation.require($scope, 'Control.Form.Email').then(function (response) {
                            Validation.isEmail($scope, 'Control.Form.Email').then(function (response) {
                            }, function (error) { });
                        }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.EmailConfirmation',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.EmailConfirmation');
                    if ($scope.Model.Data.Config.IsEmailConfirmationVisible && $scope.Model.Data.Config.IsEmailConfirmationRequired) {
                        Validation.require($scope, 'Control.Form.EmailConfirmation').then(function (response) {
                            Validation.isSame($scope, 'Control.Form.EmailConfirmation', 'Control.Form.Email', {
                                suffix: 'Mismatch'
                            }).then(function (response) {
                            }, function (error) { });
                        }, function (error) { });
                    }
                    else if ($scope.Model.Data.Config.IsEmailConfirmationVisible) {
                        Validation.isSame($scope, 'Control.Form.EmailConfirmation', 'Control.Form.Email', {
                            suffix: 'Mismatch'
                        }).then(function (response) {
                        }, function (error) { });

                    }
                }
            });

            validators.push({
                name: 'Control.Form.Phone',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Phone');
                    if ($scope.Model.Data.Config.IsPhoneVisible) {
                        if ($scope.Model.Data.Config.IsPhoneRequired) {
                            Validation.require($scope, 'Control.Form.Phone').then(function (response) {
                                if (checkoutConfig.phoneLocalizationEnabled) {
                                    var $inputPhone = $('.form-row.phone.js-phone-localization input', $element);
                                    Validation.isValidPhoneLocalized($scope, 'Control.Form.Phone', $inputPhone, $inputPhone.data('localized-validation'), {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekPhoneValidation) {
                                    $scope.Model.Data.Config.IsGreekPhone = true;
                                    Validation.isMatch($scope, 'Control.Form.Phone', /^2[0-9]{9}$/g, {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else {
                                    $scope.Model.Data.Config.IsGreekPhone = false;
                                    Validation.isMatch($scope, 'Control.Form.Phone', /^[\+]?[\d]+$/g, {

                                    }).then(function (response) {
                                    }, function (error) { });
                                }
                            }, function (error) { });
                        } else {
                            if (checkoutConfig.phoneLocalizationEnabled) {
                                var $inputPhone = $('.form-row.phone.js-phone-localization input', $element);
                                Validation.isValidPhoneLocalized($scope, 'Control.Form.Phone', $inputPhone, $inputPhone.data('localized-validation'), {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekPhoneValidation) {
                                $scope.Model.Data.Config.IsGreekPhone = true;
                                Validation.isMatch($scope, 'Control.Form.Phone', /^2[0-9]{9}$/g, {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else {
                                $scope.Model.Data.Config.IsGreekPhone = false;
                                Validation.isMatch($scope, 'Control.Form.Phone', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Mobile',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Mobile');
                    if ($scope.Model.Data.Config.IsMobileVisible) {
                        if ($scope.Model.Data.Config.IsMobileRequired) {
                            Validation.require($scope, 'Control.Form.Mobile').then(function (response) {
                                if (checkoutConfig.phoneLocalizationEnabled) {
                                    var $inputMobile = $('.form-row.mobile.js-phone-localization input', $element);
                                    Validation.isValidPhoneLocalized($scope, 'Control.Form.Mobile', $inputMobile, $inputMobile.data('localized-validation'), {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekMobileValidation) {
                                    $scope.Model.Data.Config.IsGreekMobile = true;
                                    Validation.isMatch($scope, 'Control.Form.Mobile', /^69[0-9]{8}$/g, {

                                    }).then(function (response) {
                                    }, function (error) {
                                        $scope.Control.IsOpen = true;
                                    });
                                } else {
                                    $scope.Model.Data.Config.IsGreekMobile = false;
                                    Validation.isMatch($scope, 'Control.Form.Mobile', /^[\+]?[\d]+$/g, {

                                    }).then(function (response) {
                                    }, function (error) { });
                                }
                            }, function (error) { });
                        } else {
                            if (checkoutConfig.phoneLocalizationEnabled) {
                                var $inputMobile = $('.form-row.mobile.js-phone-localization input', $element);
                                Validation.isValidPhoneLocalized($scope, 'Control.Form.Mobile', $inputMobile, $inputMobile.data('localized-validation'), {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else if ($scope.Control.Form.Country === 'GR' && checkoutConfig.greekMobileValidation) {
                                $scope.Model.Data.Config.IsGreekMobile = true;
                                Validation.isMatch($scope, 'Control.Form.Mobile', /^69[0-9]{8}$/g, {

                                }).then(function (response) {
                                }, function (error) {
                                    $scope.Control.IsOpen = true;
                                });
                            } else {
                                $scope.Model.Data.Config.IsGreekMobile = false;
                                Validation.isMatch($scope, 'Control.Form.Mobile', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Fax',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Fax');
                    if ($scope.Model.Data.Config.IsFaxVisible) {
                        if ($scope.Model.Data.Config.IsFaxRequired) {
                            Validation.require($scope, 'Control.Form.Fax').then(function (response) {
                               Validation.isMatch($scope, 'Control.Form.Fax', /^[\+]?[\d]+$/g, {

                                }).then(function (response) {
                                }, function (error) { });
                            }, function (error) { });
                        } else {
                            Validation.isMatch($scope, 'Control.Form.Fax', /^[\+]?[\d]+$/g, {

                            }).then(function (response) {
                            }, function (error) { });
                        }
                    }
                }
            });

            validators.push({
                name: 'Control.Form.PostCode',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.PostCode');
                    if ($scope.Model.Data.Config.IsPostCodeVisible && $scope.Model.Data.Config.IsPostCodeRequired) {
                        Validation.require($scope, 'Control.Form.PostCode').then(function (response) {

                            var selectedCountry = _.first(_.filter($scope.Model.Data.BillingCountries, function (x) { return x.Code === $scope.Control.Form.Country; }));
                            if ($element.data('areaautocomplete') && selectedCountry && selectedCountry.AreasCount > 1) {

                                $scope.Control.PostCodeFound = $scope.Control.Form.PostCode != "" && ($scope.Control.Form.Area != '' || ($scope.Control.Form.Area == '' && $('.PostalCodeLookUp option', $element).length > 1));

                                if ($scope.Control.PostCodeFound) {
                                    $scope.Control.Form.PostCodeInvalid = false;
                                    $scope.Control.Form.PostCodeError = false;
                                }
                                else {
                                    $scope.Control.Form.PostCodeInvalid = true;
                                    $scope.Control.Form.PostCodeError = true;
                                }
                            }
                            else {
                                $scope.Control.PostCodeFound = false;
                                $scope.Control.Form.PostCodeInvalid = false;
                                $scope.Control.Form.PostCodeError = false;
                            }

                        }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Address',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Address');
                    if ($scope.Model.Data.Config.IsAddressLine1Visible && $scope.Model.Data.Config.IsAddressLine1Required) {
                        Validation.require($scope, 'Control.Form.Address').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Streetnumber',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Streetnumber');
                    if ($scope.Model.Data.Config.IsStreetnumberVisible && $scope.Model.Data.Config.IsStreetnumberRequired) {
                        Validation.require($scope, 'Control.Form.Streetnumber').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Address2',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Address2');
                    if ($scope.Model.Data.Config.IsAddressLine2Visible && $scope.Model.Data.Config.IsAddressLine2Required) {
                        Validation.require($scope, 'Control.Form.Address2').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.City',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.City');
                    if ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityRequired) {
                        Validation.require($scope, 'Control.Form.City').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Area',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Area');
                    if ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaRequired) {
                        Validation.require($scope, 'Control.Form.Area').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Country',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Country');
                    if ($scope.Model.Data.Config.IsCountryVisible && $scope.Model.Data.Config.IsCountryRequired) {
                        Validation.require($scope, 'Control.Form.Country').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Prefecture',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Prefecture');
                    if ($scope.Model.Data.Config.IsPrefectureVisible && $scope.Model.Data.Config.IsPrefectureRequired) {
                        Validation.require($scope, 'Control.Form.Prefecture').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.CompanyName',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.CompanyName');
                    if ($scope.Model.Data.Config.IsCompanyNameVisible && $scope.Model.Data.Config.IsCompanyNameRequired) {
                        Validation.require($scope, 'Control.Form.CompanyName').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Occupation',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Occupation');
                    if ($scope.Model.Data.Config.IsOccupationVisible && $scope.Model.Data.Config.IsOccupationRequired) {
                        Validation.require($scope, 'Control.Form.Occupation').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.Headquarters',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Headquarters');
                    if ($scope.Model.Data.Config.IsHeadquartersVisible && $scope.Model.Data.Config.IsHeadquartersRequired) {
                        Validation.require($scope, 'Control.Form.Headquarters').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.TaxAgency',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.TaxAgency');
                    if ($scope.Model.Data.Config.IsTaxAgencyVisible && $scope.Model.Data.Config.IsTaxAgencyRequired) {
                        if ($scope.Model.Data.TaxAgencies[$scope.Control.SelectedCountry] && $scope.Model.Data.TaxAgencies[$scope.Control.SelectedCountry].length > 1) {
                            var firstTaxAgency = _.first(_.filter($scope.Model.Data.TaxAgencies[$scope.Control.SelectedCountry], function (x) { return x.Name == $scope.Control.Form.TaxAgency; }));
                            if (!firstTaxAgency) {
                                $scope.Control.IsValid = false;
                                $scope.Control.Form.TaxAgencyRequired = true;
                                $scope.Control.Form.TaxAgencyError = true;
                            }
                        } else {
                            Validation.require($scope, 'Control.Form.TaxAgency').then(function (response) { }, function (error) { });
                        }
                    }  
                }
            });

            validators.push({
                name: 'Control.Form.PurchaseOrderNumber',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.PurchaseOrderNumber');
                    if ($scope.Model.Data.Config.IsPurchaseOrderNumberVisible && $scope.Model.Data.Config.IsPurchaseOrderNumberRequired) {
                        Validation.require($scope, 'Control.Form.PurchaseOrderNumber').then(function (response) { }, function (error) { });
                    }
                }
            });

            validators.push({
                name: 'Control.Form.TaxIdentifier',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.TaxIdentifier');
                    Validation.require($scope, 'Control.Form.TaxIdentifier').then(function (response) {
                        var taxIdentifierIsValid = LhApp.Function.validateTaxIdentifier(true, $scope.Control.Form.Country, $scope.Control.Form.TaxIdentifier);
                        if (taxIdentifierIsValid !== true) {
                            $scope.Control.IsValid = false;
                            $scope.Control.Form.TaxIdentifierError = true;
                            $scope.Control.Form.InvalidTaxIdentifier = true;
                        }
                    }, function (error) { });
                }
            });

            $scope.Control.countryChange = function (applyChanges) {
                if ($scope.Control.Form.Country !== "GR") {
                    $scope.Control.resetVatInfo();
                    if (applyChanges) $scope.Control.applyChanges('country');
                } else {
                    if ($scope.Control.Form.IsInvoice) {
                        $scope.Control.checkVAT('country');
                    } else {
                        if (applyChanges) $scope.Control.applyChanges('country');
                    }
                }
            };

            $scope.Control.setVatStatus = function () {
                $element.get(0).set(true);
            };

            $scope.Control.getVatStatusName = function (Id) {
                var vatStatus = _.first(_.filter($scope.Model.Data.VatStatus, function (x) { return x.Value === String(Id); }));
                return vatStatus ? vatStatus.Name : vatStatus;
            };

            $scope.Control.checkVAT = $.debounce(checkoutConfig.taxIdentifierDelay, function (name) {
                var country = $scope.Control.SelectedCountry;
                var vat = $scope.Control.Form.TaxIdentifier || '';

                if (!$element.data('invoiceautocomplete') || (!savedData.hasChanged($scope.Control.Form) && getVatInfoHasRun) || country !== 'GR') return;
                    
                if (vat !== '') {

                    Vendd.Service.call({
                        url: 'EcomService.svc/GetVatInfo',
                        data: {
                            request: {
                                country: country,
                                vat: vat
                            }
                        },
                        onSuccess: function (res) {
                            $scope.Control.Form.CompanyName = '';
                            $scope.Control.Form.TaxAgency = '';
                            $scope.Control.Form.TaxAgencyId = null;
                            $scope.Control.Form.Occupation = '';
                            $scope.Control.ExcludeVatJson = '';

                            if ($scope.Control.ExcludeVat == true) {
                                $scope.Control.ExcludeVatChanged = true;
                                $scope.Control.Form.ExcludeVat = false;
                                $scope.Control.Form.NormalVat = false;
                            }

                            if (res.isValid) {
                                if (res.name !== $scope.Control.Form.CompanyName && res.name !== null && res.name !== "" && $scope.Model.Data.Config.IsCompanyNameVisible)
                                    $scope.Control.Form.CompanyName = res.name;
                                if (res.taxAgency !== $scope.Control.Form.TaxAgency && res.taxAgency !== null && res.taxAgency !== "" && $scope.Model.Data.Config.IsTaxAgencyVisible)
                                    $scope.Control.Form.TaxAgency = res.taxAgency;
                                if (res.occupation !== $scope.Control.Form.Occupation && res.occupation !== null && res.occupation !== "" && $scope.Model.Data.Config.IsOccupationVisible)
                                    $scope.Control.Form.Occupation = res.occupation;
                                if (res.normalVat)
                                    $scope.Control.Form.NormalVat = res.normalVat;
                                if (res.excludeVatJson)
                                    $scope.Control.Form.ExcludeVatJson = res.excludeVatJson;
                            }

                            $scope.Control.validateField('Control.Form.TaxIdentifier');
                            $scope.Control.validateField('Control.Form.CompanyName');
                            $scope.Control.validateField('Control.Form.TaxAgency');
                            $scope.Control.validateField('Control.Form.Occupation');


                            $scope.Control.validateField('Control.Form.TaxIdentifier');
                            $scope.Control.validateField('Control.Form.CompanyName');
                            $scope.Control.validateField('Control.Form.TaxAgency');
                            $scope.Control.validateField('Control.Form.Occupation');

                            $scope.Control.applyChanges(name);
                            getVatInfoHasRun = true;
                        },
                        onFailure: function (res) {
                            $scope.Control.applyChanges(name);
                            getVatInfoHasRun = true;
                        }
                    });
                } else {
                    if (name) $scope.Control.applyChanges(name);
                }
            });

            $scope.Control.excludeVat = function () {
                $scope.Control.ExcludeVatChanged = true;
                $scope.Control.applyChanges();
            };

            $element.get(0).validate = function (onComplete) {
                $scope.Control.IsValid = true;

                var invoiceIsOpen = $scope.Control.Form.IsInvoice && ($scope.BillingAsShipping || (!$scope.BillingAsShipping && $scope.Control.IsOpen));

                if ($scope.Control.IsOpen) {

                    if (!($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && dpScope.Control.Selected.Code === 'onSite')) {
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Title' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.FirstName' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.LastName' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Email' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.EmailConfirmation' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Phone' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Fax' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Mobile' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PostCode' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Address' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Streetnumber' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Address2' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.City' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Area' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Country' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Prefecture' })).fn();
                    }

                    if (invoiceIsOpen) {
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.CompanyName' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Occupation' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Headquarters' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.TaxAgency' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.TaxIdentifier' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PurchaseOrderNumber' })).fn();

                    }

                    if (typeof (onComplete) === 'function') {
                        setTimeout(function () {
                            onComplete($scope.Control.IsValid);
                        }, 200);
                    }
                } else {

                    if (invoiceIsOpen) {
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.CompanyName' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Occupation' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Headquarters' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.TaxAgency' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.TaxIdentifier' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PurchaseOrderNumber' })).fn();

                    }

                    if ($scope.Control.Selected === 0) {
                        if (!($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && dpScope.Control.Selected.Code === 'onSite') && checkoutConfig.billingSetDefaultAddress) {
                            Validation.require($scope, 'Control.Selected', {
                                defaultValue: '0'
                            }).then(function (response) { }, function (error) { });
                        }

                        if (typeof (onComplete) === 'function') {
                            setTimeout(function () {
                                onComplete($scope.Control.IsValid);
                            }, 200);
                        }
                    }
                    else {

                        var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.Id == $scope.Control.Selected; }));
                        angular.extend($scope.Control.Form, selectedAddress);

                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Title' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.FirstName' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.LastName' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Email' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.EmailConfirmation' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Phone' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Fax' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Mobile' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PostCode' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Address' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Streetnumber' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Address2' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.City' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Area' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Country' })).fn();
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Prefecture' })).fn();

                        if ($scope.Control.IsValid == false) {
                            Validation.reset($scope, 'Control.Form.PostCode');
                            setTimeout(function () {
                                $scope.Control.IsOpen = true;
                            }, 500);
                        }

                        if (typeof (onComplete) === 'function') {
                            setTimeout(function () {
                                onComplete($scope.Control.IsValid);
                            }, 200);
                        }
                    }

                }
                initiallyValidated = true;
            };

            $element.get(0).set = function (reloadOrder) {
                var deferred = $q.defer();

                var address = $scope.Control.IsOpen || !$scope.Order.Current.IsLoggedIn ? $scope.Control.Form : $scope.Control.Text;

                address.VatStatus = parseInt(address.VatStatus);
                if (!($scope.Control.IsOpen || !$scope.Order.Current.IsLoggedIn)) {
                    if (($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && $scope.Order.Current.DeliveryPoint.Code.indexOf('onSite') > -1) || (!($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && $scope.Order.Current.DeliveryPoint.Code.indexOf('onSite') > -1) && $scope.Control.IsOpen)) {
                        address.IsInvoice = $scope.Control.Form.IsInvoice || false;                     
                        address.CompanyName = $scope.Control.Form.CompanyName;
                        address.Occupation = $scope.Control.Form.Occupation;
                        address.Headquarters = $scope.Control.Form.Headquarters;
                        address.TaxAgency = $scope.Control.Form.TaxAgency;
                        address.TaxIdentifier = $scope.Control.Form.TaxIdentifier;
                        address.PurchaseOrderNumber = $scope.Control.Form.PurchaseOrderNumber;
                        address.TaxAgencyId = $scope.Control.Form.TaxAgencyId;
                        address.VatStatus = parseInt($scope.Control.Form.VatStatus);
                        address.eInvoice = $scope.Control.Form.eInvoice;
                    }
                }

                if (!checkoutConfig.billingSetAddressEnabled) {
                    deferred.resolve();
                    return deferred;
                }

                ControlService.invokeCheckout($scope, $element, 'SetBillingAddress', address).then(function (setResponse) {
                    $scope.setControlValue(controlName, address);

                    if (reloadOrder === true) {
                        if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                            $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                                deferred.resolve();
                                $scope.Control.Loading = false;
                            }, function (orderError) {
                                deferred.reject(orderError);
                                $scope.Control.Loading = false;
                            });
                        }
                        else {
                            deferred.resolve();
                            $scope.Control.Loading = false;
                        }
                    }
                    else {
                        deferred.resolve();
                        $scope.Control.Loading = false;
                    }

                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });

                return deferred;
            };

            $element.get(0).focus = function () {
                if (!$scope.Control.IsValid)
                    $('.x-invalid:first *[ng-model]', $element).focus();
                else
                    $('*[ng-model]:first', $element).focus();
            };

            $scope.preventPaste = function (e) {
                e.preventDefault();
                return false;
            };

            var isAddressOk = function (addr) {
                var result = true;

                if (
                    ($scope.Model.Data.Config.IsTitleVisible && $scope.Model.Data.Config.IsTitleRequired && addr.Title === '') ||
                    ($scope.Model.Data.Config.IsFirstNameVisible && $scope.Model.Data.Config.IsFirstNameRequired && addr.FirstName === '') ||
                    ($scope.Model.Data.Config.IsLastNameVisible && $scope.Model.Data.Config.IsLastNameRequired && addr.LastName === '') ||
                    ($scope.Model.Data.Config.IsEmailVisible && $scope.Model.Data.Config.IsEmailRequired && addr.Email === '') ||
                    ($scope.Model.Data.Config.IsPhoneVisible && $scope.Model.Data.Config.IsPhoneRequired && addr.Phone === '') ||
                    ($scope.Model.Data.Config.IsFaxVisible && $scope.Model.Data.Config.IsFaxRequired && addr.Fax === '') ||
                    ($scope.Model.Data.Config.IsMobileVisible && $scope.Model.Data.Config.IsMobileRequired && addr.Mobile === '') ||
                    ($scope.Model.Data.Config.IsCityVisible && $scope.Model.Data.Config.IsCityRequired && addr.City === '') ||

                    ($scope.Model.Data.Config.IsPostCodeVisible && $scope.Model.Data.Config.IsPostCodeRequired && addr.PostCode === '') ||
                    ($scope.Model.Data.Config.IsAddressLine1Visible && $scope.Model.Data.Config.IsAddressLine1Required && addr.Address === '') ||
                    ($scope.Model.Data.Config.IsStreetnumberVisible && $scope.Model.Data.Config.IsStreetnumberRequired && addr.Streetnumber === '') ||
                    ($scope.Model.Data.Config.IsAddressLine2Visible && $scope.Model.Data.Config.IsAddressLine2Required && addr.Address2 === '') ||
                    ($scope.Model.Data.Config.IsAreaVisible && $scope.Model.Data.Config.IsAreaRequired && addr.Area === '') ||
                    ($scope.Model.Data.Config.IsCountryVisible && $scope.Model.Data.Config.IsCountryRequired && addr.Country === '') ||
                    ($scope.Model.Data.Config.IsPrefectureVisible && $scope.Model.Data.Config.IsPrefectureRequired && addr.Prefecture === '')
                )
                    result = false;

                return result;
            };

            ControlService.getCheckoutData("GetBillingAddressData", $scope, $element).then(function (response) {
                $scope.Model = {};
                $scope.Control.Text = {};

                angular.extend($scope.Model, response);
                var open = false;

                var selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.IsDefault; }));
                if (selectedAddress === undefined)
                    selectedAddress = _.first($scope.Model.Data.Addresses);

                if ($scope['Order'] && $scope['Order'].Current && $scope['Order'].Current.Billing) {
                    if ($scope['Order'].Current.Billing.Id !== 0) {
                        selectedAddress = _.first(_.filter($scope.Model.Data.Addresses, function (x) { return x.Id == $scope['Order'].Current.Billing.Id; }));
                    }
                    else {
                        selectedAddress = $scope['Order'].Current.Billing;
                        open = true;
                    }
                }

                if (selectedAddress) {

                    var selectedTitle = _.first(_.filter($scope.Model.Data.Titles, function (x) { return x.Name === selectedAddress.Title; }));
                    if (!selectedTitle)
                        selectedAddress.Title = '';

                    if (!isAddressOk(selectedAddress))
                        open = true;

                    $scope.Control.Selected = selectedAddress.Id;
                    angular.extend($scope.Control.Form, selectedAddress);
                    if (open) {
                        if (!$scope.Control.Form.Country) {
                             var selectedCountry = _.find($scope.Model.Data.BillingCountries, function (x) { return x.Code == $scope.Order.Current.Shipping.Country; });
                             if (selectedCountry) {
                                 $scope.Control.Form.Country = selectedCountry.Code;
                             }
                         }

                        setFormCountry();
                        setFormVatStatus();
                        $scope.Control.IsOpen = true;
                    }
                    else {
                        angular.extend($scope.Control.Text, selectedAddress);
                        setTextCountry();
                        setTextVatStatus();
                    }
                    $scope.setControlValue(controlName, selectedAddress);
                }

                if ($element.data('areaautocomplete')) {
                    bindAreaAutoComplete();
                }

                savedData.setData($scope.Control.Form);

                $scope.Control.Loading = false;

            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

            $scope.Control.updateAddresses = function (selected) {
                $scope.BillingAddresses.Items = [];
                if (!selected || $scope.Model.Data.Addresses.length == 0) { return; }
                $scope.BillingAddresses.Selected = false;
                var ids = [];
                for (var i = 0, j = 0; i < $scope.Model.Data.Addresses.length; i++) {
                    $scope.BillingAddresses.Items.push($scope.Model.Data.Addresses[i]);

                    if (selected == $scope.BillingAddresses.Items[i].Id) {
                        $scope.BillingAddresses.Selected = true;
                        $scope.BillingAddresses.Items[i].Selected = true;
                    } else {
                        $scope.BillingAddresses.Items[i].Selected = false;
                    }
                    j++;
                }
                $scope.updateReviewBoxAddresses();
            };

            $scope.Control.hasDownloadableProducts = function () {
                var downloadableProduct = _.find($scope.Order.Current.Products, function (x) { return x.ProductType.Downlodable === true });
                return downloadableProduct !== null && downloadableProduct !== undefined;
            }

            angular.element($element.get(0)).ready(function () {
                var selectedAddress = $scope.Control.Form;
                var selectedCountry = selectedAddress ? _.first(_.filter($scope.Model.Data.BillingCountries, function (c) { return selectedAddress.Country == c.Code; })) : null;

                if (selectedAddress !== undefined && selectedAddress.PostCode != "" && selectedAddress.Area == "" && (selectedCountry ? selectedCountry.AreasCount > 1 : false)) {
                    $('input[type="text"][ng-model="Control.Form.Area"]', $element).val("");
                    $('input', $postCodeField).trigger('keyup');
                }

                if (selectedAddress !== undefined && selectedAddress.IsInvoice && (selectedAddress.ExcludeVatJson === "" || selectedAddress.ExcludeVatJson === undefined)) {
                    $scope.Control.checkVAT();
                }

                $scope.Control.updateAddresses($scope.Control.Selected);

                if (checkoutOverrides && checkoutOverrides.Generic && typeof checkoutOverrides.Generic.initPhoneLocalization === 'function') {
                    if (checkoutConfig.phoneLocalizationEnabled) checkoutOverrides.Generic.initPhoneLocalization($element.get(0), $scope);
                }  
            });

            $('input[type="text"][ng-model="Control.Form.Area"]', $element).keypress(function (e) {
                var selectedCountry = _.first(_.filter($scope.Model.Data.BillingCountries, function (x) { return x.Code === $scope.Control.Form.Country; }));
                if ($element.data('areaautocomplete') && selectedCountry.AreasCount > 1) {
                    e.preventDefault();
                }
            });

        });

})();
